import React from 'react';
import SettingsContent from 'components/admin/settings/SettingsContent';

export const SettingPage: React.FC = () => {
  return <SettingsContent />;
};
